var map = {
	"./ellipsis": 278,
	"./ellipsis.png": 278,
	"./fonts/inter.var.woff2": 686,
	"./icons/address": 279,
	"./icons/address.svg": 279,
	"./icons/arrow-down": 280,
	"./icons/arrow-down.svg": 280,
	"./icons/arrow-right": 281,
	"./icons/arrow-right.svg": 281,
	"./icons/business": 282,
	"./icons/business.svg": 282,
	"./icons/calendar": 283,
	"./icons/calendar.svg": 283,
	"./icons/cart": 284,
	"./icons/cart.svg": 284,
	"./icons/chart": 42,
	"./icons/chart.svg": 42,
	"./icons/check": 285,
	"./icons/check-white": 286,
	"./icons/check-white.svg": 286,
	"./icons/check.svg": 285,
	"./icons/chevron-down": 287,
	"./icons/chevron-down.svg": 287,
	"./icons/chevron-right": 288,
	"./icons/chevron-right.svg": 288,
	"./icons/cross": 289,
	"./icons/cross-white": 290,
	"./icons/cross-white.svg": 290,
	"./icons/cross.svg": 289,
	"./icons/discount": 291,
	"./icons/discount.svg": 291,
	"./icons/drag": 292,
	"./icons/drag-handle": 293,
	"./icons/drag-handle.svg": 293,
	"./icons/drag.svg": 292,
	"./icons/edit": 294,
	"./icons/edit.svg": 294,
	"./icons/error": 295,
	"./icons/error.svg": 295,
	"./icons/file": 296,
	"./icons/file-error": 297,
	"./icons/file-error.svg": 297,
	"./icons/file.svg": 296,
	"./icons/filter": 298,
	"./icons/filter.svg": 298,
	"./icons/graph": 299,
	"./icons/graph.svg": 299,
	"./icons/grid": 300,
	"./icons/grid.svg": 300,
	"./icons/heart": 301,
	"./icons/heart.svg": 301,
	"./icons/home": 302,
	"./icons/home.svg": 302,
	"./icons/image": 303,
	"./icons/image.svg": 303,
	"./icons/inventory": 304,
	"./icons/inventory.svg": 304,
	"./icons/kebab": 64,
	"./icons/kebab.svg": 64,
	"./icons/mail": 305,
	"./icons/mail.svg": 305,
	"./icons/money": 306,
	"./icons/money.svg": 306,
	"./icons/orders": 307,
	"./icons/orders.svg": 307,
	"./icons/organization": 308,
	"./icons/organization.svg": 308,
	"./icons/package": 309,
	"./icons/package.svg": 309,
	"./icons/pdf": 310,
	"./icons/pdf.svg": 310,
	"./icons/phone": 311,
	"./icons/phone.svg": 311,
	"./icons/plus": 312,
	"./icons/plus.svg": 312,
	"./icons/screenshot": 313,
	"./icons/screenshot.svg": 313,
	"./icons/settings": 314,
	"./icons/settings.svg": 314,
	"./icons/shipments": 315,
	"./icons/shipments.svg": 315,
	"./icons/shopping-bag": 316,
	"./icons/shopping-bag.svg": 316,
	"./icons/store": 317,
	"./icons/store.svg": 317,
	"./icons/table": 318,
	"./icons/table.svg": 318,
	"./icons/trash": 319,
	"./icons/trash.svg": 319,
	"./icons/truck": 320,
	"./icons/truck-error": 321,
	"./icons/truck-error.svg": 321,
	"./icons/truck.svg": 320,
	"./icons/user": 322,
	"./icons/user.svg": 322
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 685;